module.exports = __webpack_public_path__ + "img/openai.f07ee8c6.png";